import React from 'react';
import { Link } from 'react-router-dom';
import { debtResolutionProcessSteps } from '../data/sharedSteps';
import { PAGE_META } from '../data/pageMetaConfig';
import SimpleContactButton from '../components/SimpleCBT';

const linkClass = 'text-amber-600 hover:text-amber-700 font-semibold underline';
const path = '/execution-lawyer';

export const pageMeta = {
  title: PAGE_META[path].title,
  metaDescription: PAGE_META[path].description,
  path,
  h1: 'עורך דין הוצאה לפועל',
  faqSubtitle: 'מצאו תשובות לשאלות נפוצות בנוגע להוצאה לפועל, עיקולים ואיחוד תיקים.',
};

export const steps = debtResolutionProcessSteps;

export const faq = [
  {
    question: 'קיבלתי אזהרה מהוצאה לפועל – מה זה אומר?',
    answer:
      'אזהרה היא הודעה רשמית שנפתח נגדכם תיק בהוצאה לפועל. זה השלב שבו חשוב לבדוק את החוב, להבין את האפשרויות שלכם ולפעול בזמן.',
  },
  {
    question: 'האם אפשר לבטל עיקול על חשבון הבנק?',
    answer:
      'במקרים מסוימים אפשר להגיש בקשה לביטול או צמצום עיקול, אך הדבר תלוי בנסיבות התיק, סוג החוב, מצב החייב והמסמכים שמוצגים.',
  },
  {
    question: 'האם אפשר לפרוס חוב בהוצאה לפועל?',
    answer:
      'כן, ניתן במקרים המתאימים לבקש הסדרת תשלומים בהתאם ליכולת הכלכלית, בכפוף להחלטת רשם ההוצאה לפועל.',
  },
  {
    question: 'מה זה איחוד תיקים?',
    answer:
      'איחוד תיקים הוא הליך שמאפשר לרכז כמה תיקי הוצאה לפועל למסגרת אחת ולשלם סכום חודשי אחד, כפי שייקבע על ידי רשם ההוצאה לפועל.',
  },
  {
    question: 'האם איחוד תיקים מוחק את החובות?',
    answer:
      'לא. איחוד תיקים לא מוחק את החובות, אלא מסדיר את אופן התשלום שלהם במסגרת אחת. במקרים מסוימים, אם אין יכולת אמיתית לפרוע את החובות, צריך לבחון אפשרויות אחרות כמו חדלות פירעון.',
  },
  {
    question: 'האם אפשר להגיש התנגדות לתיק הוצאה לפועל?',
    answer:
      'במקרים מסוימים כן, במיוחד בתיקים שנפתחו בעקבות שטר, שיק או תביעה על סכום קצוב. חשוב לבדוק את סוג התיק ואת המועדים הרלוונטיים בהקדם.',
  },
  {
    question: 'מה עושים אם החוב כבר שולם?',
    answer:
      'אם החוב שולם או שיש טענה שהחוב לא קיים, חשוב לבדוק את המסמכים ולהגיש בקשה מתאימה במסגרת ההוצאה לפועל.',
  },
  {
    question: 'מה עושים אם אני לא יכול לשלם את החוב בבת אחת?',
    answer:
      'במקרים המתאימים, ניתן לבחון הגשת בקשה לצו תשלומים, ניסיון להגיע להסדר מול הנושה או בחינה של פתרון רחב יותר כמו איחוד תיקים או חדלות פירעון. הדבר החשוב הוא לפעול בזמן, לפני שהחוב גדל וההליכים מחמירים.',
  },
];

export const sections = [
  {
    title: 'קיבלתם אזהרה, עיקול או תיק בהוצאה לפועל? חשוב לפעול נכון',
    content: (
      <>
        <p>
          אם נפתח נגדכם תיק בהוצאה לפועל, קיבלתם אזהרה, הוטל עיקול על חשבון הבנק או שאתם מרגישים
          שהחובות מתחילים לנהל לכם את החיים – חשוב לדעת שאתם לא חייבים להתמודד עם זה לבד. הרבה
          אנשים נלחצים כשהם רואים מכתב מהוצאה לפועל. חלק מתעלמים, חלק מנסים לשלם בלי לבדוק, וחלק
          לוקחים עוד הלוואה רק כדי &quot;לכבות שריפה&quot;. בפועל, דווקא בשלב הזה חשוב לעצור,
          להבין מה באמת קורה בתיק, ולבחור דרך פעולה נכונה.
        </p>
        <p>
          הליכי הוצאה לפועל יכולים לכלול עיקולים, הגבלות, דרישות תשלום, תיקים שנפתחים בעקבות
          שיקים, פסקי דין, חובות כספיים או תביעות על סכום קצוב. אבל במקרים רבים קיימות אפשרויות
          פעולה: בקשה לצו תשלומים, איחוד תיקים,{' '}
          <Link to="/debt-settlement-lawyer" className={linkClass}>
            הסדר חוב
          </Link>
          , התנגדות, בקשה לביטול או צמצום עיקול, ולעיתים גם בחינה של הליך{' '}
          <Link to="/insolvency-lawyer" className={linkClass}>
            חדלות פירעון
          </Link>
          .
        </p>
        <p>
          במשרד מיכלסון ושות׳ אנחנו מלווים חייבים בהליכי הוצאה לפועל, מטפלים בעיקולים, הגבלות,
          בקשות לצווי תשלומים, איחוד תיקים, הסדרי חוב והתנהלות מול נושים ולשכות ההוצאה לפועל.
          המטרה שלנו היא פשוטה: לבדוק את מצב התיקים שלכם, להבין מה האפשרויות המשפטיות שעומדות
          בפניכם, ולבנות עבורכם דרך פעולה מסודרת שתאפשר לכם להחזיר שליטה.
        </p>
      </>
    ),
  },
  {
    title: 'מה זה תיק הוצאה לפועל?',
    content: (
      <>
        <p>
          תיק הוצאה לפועל הוא הליך שנפתח כדי לגבות חוב מאדם או עסק. החוב יכול לנבוע, למשל, מפסק
          דין, שיק שחזר, שטר חוב, תביעה על סכום קצוב, חוב מזונות או חיוב אחר שניתן לגבות במסגרת
          ההוצאה לפועל. במילים פשוטות: אם מישהו טוען שאתם חייבים לו כסף ויש לו מסמך שמאפשר פתיחת
          תיק – הוא יכול לפנות להוצאה לפועל ולבקש להתחיל בהליכי גבייה.
        </p>
        <p>
          אחרי פתיחת תיק, בדרך כלל נשלחת לחייב אזהרה. האזהרה היא הודעה רשמית שמעדכנת את החייב
          שנפתח נגדו תיק, ומפרטת את האפשרויות שעומדות בפניו. לפי רשות האכיפה והגבייה, תקופת
          האזהרה היא פרק הזמן שבו בדרך כלל לא ננקטים הליכים נגד החייב, למעט חריגים. לכן חשוב לא
          להתעלם מאזהרה. זה בדיוק השלב שבו צריך לבדוק את התיק, להבין את סוג החוב, ולבחור איך נכון
          לפעול.
        </p>
      </>
    ),
  },
  {
    title: 'קיבלתם אזהרה מהוצאה לפועל – מה עושים עכשיו?',
    content: (
      <>
        <p>
          אם קיבלתם אזהרה, הדבר הכי חשוב הוא לא להתעלם. האזהרה היא לא &quot;סתם מכתב&quot;. היא
          הודעה רשמית על כך שנפתח נגדכם תיק, והיא מסמנת את השלב שבו צריך לבדוק את הזכויות
          והאפשרויות שלכם. בשלב הזה כדאי לבדוק:
        </p>
        <ul>
          <li>מי פתח את התיק?</li>
          <li>על איזה חוב מדובר?</li>
          <li>האם סכום החוב נכון?</li>
          <li>האם כבר שילמתם חלק מהחוב?</li>
          <li>האם יש לכם טענות נגד החוב?</li>
          <li>האם יש אפשרות להסדר?</li>
          <li>האם צריך להגיש התנגדות?</li>
          <li>האם יש צורך בצו תשלומים או איחוד תיקים?</li>
        </ul>
        <p>ככל שפועלים מוקדם יותר, כך יש יותר אפשרויות לטפל נכון בתיק ולמנוע החמרה.</p>
      </>
    ),
  },
  {
    title: 'מתי כדאי לפנות לעורך דין הוצאה לפועל?',
    content: (
      <>
        <p>
          לא כדאי לחכות שהמצב יחמיר. הרבה פעמים פעולה מוקדמת יכולה למנוע עיקולים, הגבלות, ריביות,
          הוצאות נוספות ולחץ מיותר. כדאי לפנות לייעוץ אם אתם מזהים אחד או יותר מהמצבים הבאים:
        </p>
        <ul>
          <li>קיבלתם אזהרה מהוצאה לפועל.</li>
          <li>נפתח נגדכם תיק בגלל שיק שחזר או פסק דין.</li>
          <li>הוטל עיקול על חשבון הבנק, המשכורת או הרכב.</li>
          <li>יש לכם כמה תיקים פתוחים בהוצאה לפועל.</li>
          <li>אתם לא מצליחים לעמוד בתשלומים שנדרשים מכם.</li>
          <li>קיבלתם התראה לפני הגבלה או הליך גבייה.</li>
          <li>אתם חושבים שהחוב לא נכון, שולם כבר או מנופח.</li>
          <li>אתם רוצים להגיע להסדר חוב מול הנושים.</li>
          <li>
            אתם לא יודעים אם עדיף צו תשלומים, איחוד תיקים או{' '}
            <Link to="/insolvency-lawyer" className={linkClass}>
              חדלות פירעון
            </Link>
            .
          </li>
        </ul>
        <p>
          בשלב הזה חשוב לא לפעול מתוך פחד. צריך לבדוק מה מקור החוב, מה מצב התיק, אילו הליכים כבר
          ננקטו, והאם קיימת דרך לעצור או לצמצם את הפגיעה.
        </p>
        <div className="not-prose">
          <SimpleContactButton className="mt-8 !mb-8" />
        </div>
      </>
    ),
  },
  {
    title: 'איך עורך דין הוצאה לפועל יכול לעזור?',
    content: (
      <>
        <p>
          עורך דין הוצאה לפועל לא רק מגיש בקשות. התפקיד שלו הוא להבין את התמונה המלאה, לבדוק את
          מצב החובות, לזהות טעויות או אפשרויות פעולה, ולבחור את הדרך הנכונה לטיפול בתיק. במשרדנו
          הליווי כולל בין היתר:
        </p>
        <h3>בדיקת מצב התיקים והחובות</h3>
        <p>
          בשלב הראשון אנחנו בודקים אילו תיקים פתוחים נגדכם, מי הנושים, מה סכומי החוב, אילו הליכים
          ננקטו, האם קיימים עיקולים או הגבלות, והאם יש טענות שצריך להעלות. המטרה היא להבין איפה
          אתם עומדים באמת – ולא רק לפי המכתב האחרון שקיבלתם.
        </p>
        <h3>טיפול בעיקולים והגבלות</h3>
        <p>
          אם הוטל עיקול על חשבון הבנק, המשכורת, הרכב או נכסים אחרים, ניתן במקרים המתאימים להגיש
          בקשות לביטול, צמצום או שינוי העיקול. חשוב לדעת: לא כל עיקול מתבטל אוטומטית, וכל בקשה
          נבחנת לפי נסיבות המקרה. לכן צריך להציג את המצב בצורה מסודרת ולפעול נכון מול לשכת
          ההוצאה לפועל.
        </p>
        <h3>בקשה לצו תשלומים</h3>
        <p>
          במקרים שבהם החייב לא יכול לשלם את מלוא החוב בבת אחת, ניתן לבחון הגשת בקשה להסדרת
          תשלומים בהתאם ליכולת הכלכלית. המטרה היא לאפשר התנהלות מסודרת יותר, להפחית לחץ, ולנסות
          למנוע נקיטת הליכים נוספים ככל שניתן ובהתאם להחלטות רשם ההוצאה לפועל.
        </p>
        <h3>איחוד תיקים</h3>
        <p>
          כאשר יש כמה תיקים פתוחים בהוצאה לפועל, ניתן במקרים מסוימים לבקש איחוד תיקים. איחוד
          תיקים מאפשר לרכז מספר תיקים תחת מסגרת אחת, ולשלם מדי חודש סכום שייקבע על ידי רשם
          ההוצאה לפועל. רשות האכיפה והגבייה מציינת כי השירות נועד לחייבים שיש להם כמה תיקים שבהם
          הם חייבים כספים. חשוב להבין שאיחוד תיקים לא מתאים לכל אחד, ולכן צריך לבדוק האם זו באמת
          האפשרות הנכונה או שיש פתרון מתאים יותר.
        </p>
        <h3>התנגדות לתיק שנפתח</h3>
        <p>
          במקרים מסוימים, אם נפתח תיק בעקבות שיק, שטר חוב או תביעה על סכום קצוב, ניתן להגיש
          התנגדות לחלק מהחוב או למלוא החוב. רשות האכיפה והגבייה מציינת שניתן להגיש התנגדות בתיקים
          מסוג שטרות או תביעה על סכום קצוב. כאן חשוב במיוחד לא להתמהמה, כי יש מועדים קצרים וחשוב
          לבדוק את התיק בזמן.
        </p>
        <h3>ניהול משא ומתן להסדר חוב</h3>
        <p>
          לפעמים הדרך הנכונה היא לא לנהל מאבק ארוך, אלא לנסות להגיע להסדר מול הנושה. במסגרת{' '}
          <Link to="/debt-settlement-lawyer" className={linkClass}>
            הסדר חוב
          </Link>{' '}
          ניתן לנסות להגיע לפריסה, הפחתה מסוימת או תשלום מוסכם שיביא לסגירת התיק, בהתאם לנסיבות
          ולנכונות הצדדים.
        </p>
      </>
    ),
  },
];
